const SELECTOR = '.collection-banner-new__select';

function initCollectionBannerSelect(select) {
  if (select.dataset.collectionBannerInitialized === 'true') return;

  const listbox = select.querySelector('.custom-select__listbox');

  if (listbox) {
    listbox.focus = function focusWithoutScroll() {
      HTMLElement.prototype.focus.call(this, { preventScroll: true });
    };
  }

  select.addEventListener('change', (event) => {
    const url = event.detail && event.detail.selectedValue;

    if (url) window.location.href = url;
  });

  select.dataset.collectionBannerInitialized = 'true';
}

function initCollectionBannerSelects(container = document) {
  customElements.whenDefined('custom-select').then(() => {
    container.querySelectorAll(SELECTOR).forEach(initCollectionBannerSelect);
  });
}

initCollectionBannerSelects();

document.addEventListener('shopify:section:load', (event) => {
  initCollectionBannerSelects(event.target);
});
